// App-level configuration that is not a scoring number (rule 1 is about ruleset
// values, not identifiers). There is no season-list endpoint; the league runs a
// single active season, id 1 (seed/seed.sql). Boards and the schedule need it.
export const SEASON_ID = 1;
